(ns minorodata.localforage.events
  (:require [minorodata.localforage.core :refer [db]]
            [applied-science.js-interop :as js-interop]
            [minorodata.app.handlers :refer [reg-event-fx]]))

(reg-event-fx
:localforage.events/store
 (fn [_ [key value callback]]
   (js-interop/call db :setItem key value (or callback (fn [])))
   nil))

(reg-event-fx
:localforage.events/get
 (fn [_ [key callback]]
   (js-interop/call db :getItem key (or callback (fn [])))
   nil))

